export function Logo({ variant = "grad", className = "h-9 w-9", ...props }) {
  return <img src={`/logo/E-${variant}.svg`} alt="Elysium" className={className} draggable={false} {...props} />;
}

export function WordMark({ variant = "grad", className = "h-6", ...props }) {
  return <img src={`/logo/Elysium-${variant}.svg`} alt="Elysium Training Club" className={className} draggable={false} {...props} />;
}
